import React from 'react';
import { cn } from '../../lib/utils.ts';
import { fieldFocusClasses, fieldInvalidClasses } from './fieldStyles.ts';

type InlineInputProps = React.InputHTMLAttributes<HTMLInputElement> & {
  className?: string;
  selectOnFocus?: boolean;
};

export function InlineInput({
  className,
  selectOnFocus = false,
  onFocus,
  ...props
}: InlineInputProps) {
  const handleFocus = (e: React.FocusEvent<HTMLInputElement>) => {
    if (selectOnFocus) {
      const input = e.currentTarget;
      requestAnimationFrame(() => input.select());
    }
    onFocus?.(e);
  };

  return (
    <input
      {...props}
      onFocus={handleFocus}
      className={cn(
        "w-full px-2 py-1 text-sm bg-transparent border-0 rounded-md cursor-text hover:bg-gray-50 focus:bg-white",
        fieldFocusClasses,
        fieldInvalidClasses,
        className,
      )}
    />
  );
}

export default InlineInput;
